import React from 'react';
import { Link } from 'react-router-dom';
import { company, navigation } from '../data/siteData';

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="site-footer__top">
        <div>
          <Link className="wordmark site-footer__wordmark" to="/">
            <span className="wordmark__mark" aria-hidden="true">
              <img src="/logo.png" alt="" />
            </span>
            <span className="wordmark__type">
              <strong>RYU</strong>
              <small>CORPORATION</small>
            </span>
          </Link>
          <p>LIQUOR WHOLESALE / EC / DISTRIBUTION</p>
        </div>
        <div className="site-footer__nav">
          <nav aria-label="フッターナビゲーション">
            <p>NAVIGATION</p>
            {navigation.map((item) => <Link key={item.label} to={item.to}>{item.label}</Link>)}
            <Link to="/contact">CONTACT</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/faqplus">偽物ウイスキーの見分け方</Link>
          </nav>
          <div>
            <p>COMPANY</p>
            <span>{company.name}</span>
            <span>〒{company.postalCode}</span>
            <span>{company.address}</span>
            <a href={`tel:${company.phone.replaceAll('-', '')}`}>{company.phone}</a>
            <a href={`mailto:${company.email}`}>{company.email}</a>
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} RYU CORPORATION.</span>
        <span>DRINK RESPONSIBLY.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
